import { FunctionComponent } from 'react';
import {
  AlternativeProductViewModel,
  AlternativeProductType
} from '../types/generated';
import { TransactionalCurrency } from '../types/enums';
import formatCurrency from '../utilities/formatCurrency';

interface AlternativeProductPodProps {
  alternativeProducts: AlternativeProductViewModel[] | null;
  transactionalCurrency?: TransactionalCurrency;
}

const AlternativeProductPod: FunctionComponent<AlternativeProductPodProps> = ({
  transactionalCurrency,
  alternativeProducts
}) => {
  if (!alternativeProducts) {
    return null;
  }

  return (
    <div>
      {alternativeProducts.map((product) => {
        if (
          product.alternativeProductType !== AlternativeProductType.classmates
        ) {
          return null;
        }

        return (
          <section key={product.productId}>
            <div className="pdp-classmates-alternative">
              <div className="pdp-classmates-alternative__header">
                <div className="pdp-classmates-alternative__logo" />
                <div className="pdp-classmates-alternative__saving">
                  Save{' '}
                  <span className="pdp-classmates-alternative__saving-highlight">
                    {formatCurrency(
                      product.savingsAmount,
                      transactionalCurrency
                    )}
                  </span>{' '}
                  by switching to Classmates
                </div>
              </div>

              <div className="pdp-classmates-alternative__img">
                <img
                  src={`${product.imageUrl}?width=320`}
                  alt={product.name || ''}
                />
              </div>

              <h3 className="pdp-classmates-alternative__title">
                {product.name}
              </h3>
              <div className="pdp-classmates-alternative__price">
                {formatCurrency(product.priceExcVat, transactionalCurrency)}{' '}
                <span className="font-weight-normal">ex VAT</span>
              </div>
              <div className="pdp-classmates-alternative__btn">
                <a
                  href={product.urlPath || ''}
                  className="btn btn--switch-item btn-block"
                >
                  Switch Now
                </a>
              </div>
            </div>
            <div className="money-back">
              <div className="money-back__logo">
                <img
                  src="/images/savings/money-back-guarantee.png"
                  alt="Money Back Guarantee"
                />
              </div>
              <div className="money-back__text">
                If you&apos;re not happy we&apos;ll give you your money back
              </div>
            </div>
          </section>
        );
      })}
    </div>
  );
};

export default AlternativeProductPod;
